export const SHIPPING_METHOD_CODES: Record<string, string> = {
  Dagbezorging: 'smDay',
  Nachtbezorging: 'smNight',
  'Afhalen bij de balie': 'smPickUpAtCounter',
  'Ander adres kiezen': 'smDay',
};